import { useState } from 'react';

const useManagePageLoading = (
  defaultValue = { message: '', loading: false }
) => {
  const [modalLoading, setModalLoading] = useState({
    message: defaultValue.message,
    loading: defaultValue.loading
  });

  const handleLoading = (loading, message = '') => {
    setModalLoading({ message: message, loading: loading });
  };

  return [modalLoading.loading, modalLoading.message, handleLoading];
};

export default useManagePageLoading;
